import axios from 'axios';

import routes from 'app/routes';

export default {
  loadEnterprise: (dispatch, enterpriseId, afterCallback = () => {}) => {
    axios
      .get(routes.api.enterprises.show(enterpriseId))
      .then((response) => {
        dispatch({
          type: 'LOAD_ENTERPRISE',
          enterpriseAttributes: response.data.data.attributes,
        });
        afterCallback();
      });
  },

  updateEnterprise: (dispatch, enterpriseId, values, successCallback, errorCallback) => {
    const formData = new FormData();

    if (typeof values.logo === 'string') {
      delete values.logo;
    }

    Object.keys(values).forEach((key) => {
      formData.append(key, values[key] === null ? '' : values[key]);
    });

    axios
      .patch(routes.api.enterprises.update(enterpriseId), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        dispatch({
          type: 'UPDATE_ENTERPRISE',
          enterpriseAttributes: response.data.data.attributes,
        });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },
};
